<!--
 * @Description: 
 * @version: 
 * @Date: 2024-01-11 09:55:50
 * @LastEditTime: 2024-02-05 14:24:33
-->
<template>
  <div class="header-section">
    <div class="header-fl">
      <div @click="toggleSideMenu">
        <DoubleRightOutlined v-if="isCollapse"
                             class="icon-style pointer" />
        <DoubleLeftOutlined v-else
                            class="icon-style pointer" />
      </div>
    </div>

    <div class="header-fr">

      <a-dropdown>
        <div class="user-avatar">
          <a-avatar src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" />
          <div class="user-name">{{useUserStore().userInfo?.employeeName}}</div>
        </div>
        <template #overlay>
          <a-menu>
            <a-menu-item>
              <a href="javascript:;"
                 @click="clickChangePwd">修改密码</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;"
                 @click="onLogout">退出登录</a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>

    </div>
  </div>

  <ChangePwdModal ref="changePwdModalRef" />
</template>

<script setup>
import { ref, computed } from 'vue';
import { useSystemStore } from '@/store/system.js';
import { useUserStore } from '@/store/user.js';
import ChangePwdModal from './components/change-pwd-modal.vue';

// 菜单是否折叠状态
const isCollapse = computed(() => useSystemStore().getSideMenuCollapse);

const toggleIconStyle = {};

function toggleSideMenu() {
  const value = isCollapse.value ? false : true;
  useSystemStore().setSideMenuCollapse(value);
}

/**
 * 修改密码
 */
const changePwdModalRef = ref();

function clickChangePwd() {
  changePwdModalRef.value.showModal();
}

/**
 * 退出登录
 */
function onLogout() {
  useUserStore().logout();
}
</script>

<style lang='less' scoped>
.header-section {
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  .header-fl {
    flex: 1;
    column-gap: 16px;
    overflow: hidden;
    display: flex;
    align-items: center;
    .icon-style {
      color: #fff;
      font-size: 20px;
      &.pointer {
        cursor: pointer;
      }
    }
  }

  .header-fr {
    .user-avatar {
      display: flex;
      align-items: center;
      column-gap: 8px;
      cursor: pointer;
      .user-name {
        color: #f2f2f2;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }
}
</style>